/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 媒体模块路由
 */

const MediaList = () => import('@/views/media/medias.vue')
// const SelfMediaList = () => import('@/views/media/selfMedias.vue')
const MediaEdit = () => import('@/views/media/edit.vue')
const MediaCreate = () => import('@/views/media/create.vue')
const MediaOrgList = () => import('@/views/media/orgList.vue')
const MediaOrgEdit = () => import('@/views/media/orgEdit.vue')
const MediaOrgCreate = () => import('@/views/media/orgCreate.vue')
const MediaOrgDetail = () => import('@/views/media/orgDetail.vue')
const MediaPlatforms = () => import('@/views/media/platforms.vue')
const MediaRelations = () => import('@/views/media/relations.vue')
const MediaPublicReporter = () => import('@/views/media/publicReporter.vue')
const MediaRelationCreate = () => import('@/views/media/relationCreate.vue')
const MediaRelationEdit = () => import('@/views/media/relationEdit.vue')
const MediaPhoneExamine = () => import('@/views/media/mediaPhoneExamine.vue')
const MediaAuth = () => import('@/views/media/auth.vue')
const MediaAuthDetail = () => import('@/views/media/authDetail.vue')
const MediaSplider = () => import('@/views/media/splider/index.vue') 
const CreateMediaSplider = () => import('@/views/media/splider/create.vue') 
const MediaSpliderDetail = () => import('@/views/media/splider/detail.vue') 
const MediaStore = () => import('@/views/media/store/index.vue')
const MediaStoreDetail = () => import('@/views/media/store/detail.vue')
const MediaNews = () => import('@/views/media/news.vue')
const Mediaxpath = () => import('@/views/media/xpath.vue')

/* Layout */
import Layout from '@/layout/index.vue'

export default {
    path: '/media',
    component: Layout,
    redirect: '/media/list',
    meta: {
        title: '媒体',
        icon: 'icon-org',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'medias',
            component: MediaList,
            name: 'MediaList',
            meta: {
                title: '新闻媒体名单'
            }
        },
        // {
        //     path: 'self-medias',
        //     component: SelfMediaList,
        //     name: 'SelfMediaList',
        //     meta: {
        //         title: '自媒体名单'
        //     }
        // },
        {
            path: ':id/edit',
            component: MediaEdit,
            name: 'MediaEdit',
            meta: {
                title: '媒体编辑',
                hidden: true
            }
        },
        {
            path: 'create',
            component: MediaCreate,
            name: 'MediaCreate',
            meta: {
                title: '媒体创建',
                hidden: true
            }
        },
        {
            path: ':id/platforms',
            component: MediaPlatforms,
            name: 'MediaPlatforms',
            meta: {
                title: '各平台关联的媒体号',
                hidden: true
            }
        },
        {
            path: 'org-list',
            component: MediaOrgList,
            name: 'MediaOrgList',
            meta: {
                title: '集团关系'
            }
        },
        {
            path: 'org/:id/edit',
            component: MediaOrgEdit,
            name: 'MediaOrgEdit',
            meta: {
                title: '集团编辑',
                hidden: true
            }
        },
        {
            path: 'org/create',
            component: MediaOrgCreate,
            name: 'MediaOrgCreate',
            meta: {
                title: '集团创建',
                hidden: true
            }
        },
        {
            path: 'org/:id',
            component: MediaOrgDetail,
            name: 'MediaOrgDetail',
            meta: {
                title: '集团详情',
                hidden: true
            }
        },
        {
            path: 'relations',
            component: MediaRelations,
            name: 'MediaRelations',
            meta: {
                title: '父子关系'
            }
        },
        {
            path: 'public',
            component: MediaPublicReporter,
            name: 'MediaPublicReporter',
            meta: {
                title: '共用记者'
            }
        },
        {
            path: 'relation/create',
            component: MediaRelationCreate,
            name: 'MediaRelationCreate',
            meta: {
                title: '创建关系',
                hidden: true
            }
        },
        {
            path: 'relation/:id/edit',
            component: MediaRelationEdit,
            name: 'MediaRelationEdit',
            meta: {
                title: '编辑关系',
                hidden: true
            }
        },
        {
            path: 'phone/examine',
            component: MediaPhoneExamine,
            name: 'MediaPhoneExamine',
            meta: {
                title: '联系热线审核'
            }
        },
        {
            path: 'auth',
            component: MediaAuth,
            name: 'MediaAuth',
            meta: {
                title: '报社认证'
            }
        },
        {
            path: 'auth/:id',
            component: MediaAuthDetail,
            name: 'MediaAuthDetail',
            meta: {
                title: '认证详情',
                hidden: true
            }
        },
        {
            path: 'splider',
            component: MediaSplider,
            name: 'MediaSplider',
            meta: {
                title: '爬虫定制'
            }
        },
        {
            path: 'splider/create',
            component: CreateMediaSplider,
            name: 'CreateMediaSplider',
            meta: {
                title: '新建爬虫定制配置',
                hidden: true
            }
        },
        {
            path: 'splider/:id',
            component: MediaSpliderDetail,
            name: 'MediaSpliderDetail',
            meta: {
                title: '爬虫定制配置详情',
                hidden: true
            }
        },
        {
            path: 'store',
            component: MediaStore,
            name: 'MediaStore',
            meta: {
                title: '收录审核'
            }
        },
        {
            path: 'news',
            component: MediaNews,
            name: 'MediaNews',
            meta: {
                title: '文章补录'
            }
        },
        {
            path: 'store/:id',
            component: MediaStoreDetail,
            name: 'MediaStoreDetail',
            meta: {
                title: '收录详情',
                hidden: true
            }
        },
        {
            path: 'xpath',
            component: Mediaxpath,
            name: 'Mediaxpath',
            meta: {
                title: 'XPath工具'
            }
        }
    ]
}
